import { ModalConfig } from '@contexts/modalContext';
import { MonthlySlcspPremiumModal } from './MonthlySlcspPremiumModal';

export const monthlySlcspPremiumModalConfig: ModalConfig = {
    monthlySlcspPremiumModal: {
        id: 'monthlySlcspPremiumModal',
        modalComponent: MonthlySlcspPremiumModal,
    },
};
